import React from "react";

import destination_1 from "../../public/wheretogo-krkonose/cernahora/destination_1.png";
import destination_2 from "../../public/wheretogo-krkonose/cernahora/destination_2.png";
import destination_3 from "../../public/wheretogo-krkonose/cernahora/destination_3.png";
import destination_4 from "../../public/wheretogo-krkonose/cernahora/destination_4.png";
import destination_5 from "../../public/wheretogo-krkonose/cernahora/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-krkonose/cernahora/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-krkonose/cernahora/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-krkonose/cernahora/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-krkonose/cernahora/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const CernaHora = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Černá hora</h1>
            <p>
              Černá hora s nadmořskou výškou 1299 metrů leží ve východních
              Krkonoších. Kousek od vrcholu se nachází Černohorské rašeliniště,
              které je velmi turisticky vyhledávané. V zimě je oblast hojně
              využívána lyžaři, v létě turisty.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>lanovka</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>horské kolo</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>turistické trasy</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>ubytování</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Původní lanovka na Černou horu fungovala již od roku 1928. V
                  současné době nás na vrchol vyveze nová kabinová lanovka,
                  které se říká Černohorský expres
                </li>
                <li>
                  Na vrcholu Černé hory je z původního sloupu staré lanové dráhy
                  vystavěná rozhledna, z jejíž vyhlídkové plošiny je ojedinělý
                  pohled do kraje pod Černou horou a na část Krkonoš.
                </li>
                <li>
                  V blízkosti vrcholu Černé hory se nachází přírodní rezervace
                  Černohorská rašeliniště – největší rašeliniště lesního typu v
                  Krkonoších
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CernaHora;
